import React, { MouseEvent } from 'react';
import classNames from 'classnames';
import {
    useActiveInputSupportsFilter,
    useUpdateActiveFilter,
} from 'portfolio/hooks';
import { Button } from '@instinet-analytics/semantic-ui-components';
import {
    PubSub,
    textUtils,
    Tooltip,
    TooltipText,
} from '@instinet-analytics/core-lib';
import './PortfolioSummaryAddFilterButton.scss';
import './PortfolioSummaryAddFilterButton.scss';
import { getAggregationStrategy } from 'widgets/portfolioSummary/aggregation/strategies/AggregationStrategyFactory';
import { useSelectAppSettings } from 'app/store/appSettings/selectors';
import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';

const { pluralise } = textUtils;

interface PortfolioSummaryAddFilterButtonProps {
    changedFilterRef: PubSub<void>;
    className?: string;
    selectedValues: string[];
    aggregationField: AggregationField;
}

export function PortfolioSummaryAddFilterButton(
    props: PortfolioSummaryAddFilterButtonProps
) {
    const { aggregationField, changedFilterRef, className, selectedValues } =
        props;

    const activeInputSupportsFilter = useActiveInputSupportsFilter();
    const updateFilter = useUpdateActiveFilter(aggregationField);
    const { combineSellsAndShorts } = useSelectAppSettings();

    const aggregationStrategy = getAggregationStrategy(
        aggregationField,
        combineSellsAndShorts
    );

    if (
        !activeInputSupportsFilter ||
        selectedValues.length === 0 ||
        !aggregationStrategy.groupNameToValue
    ) {
        return <></>;
    }

    const groupNameToValue =
        aggregationStrategy.groupNameToValue.bind(aggregationStrategy);

    const tooltip: TooltipText = {
        body: (
            <div>
                Add the selected {selectedValues.length}{' '}
                {pluralise(selectedValues.length, 'row')} to the active filter.
                <div>Shift-click to add as exclusions.</div>
            </div>
        ),
    };

    const onClick = (e: MouseEvent<HTMLButtonElement>) => {
        const mappedValues = selectedValues.map((s) => groupNameToValue(s));
        updateFilter(e.shiftKey, mappedValues);
        changedFilterRef.publish();
    };

    return (
        <div
            className={classNames('PortfolioSummaryAddFilterButton', className)}
        >
            <Tooltip text={tooltip}>
                <Button onClick={onClick}>Add Filter</Button>
            </Tooltip>
        </div>
    );
}
